<!--
  ~ Copyright (C) 2018 Robert Bosch Manufacturing Solutions GmbH, Germany. All rights reserved.
  -->

<bci-app [sidebarLinks]="auth.sidebarLinks" [sidebarFooterLinks]="sidebarFooterLinks">
  <router-outlet></router-outlet>
</bci-app>
